<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 94 76"
        fill="none"
        width="94"
        height="76"
        class="ml-4 inline-block size-9 md:size-10 lg:size-16 xl:size-[4.5rem]">
        <path
            opacity="0.5"
            d="M2 37.9633L31.4444 72L92 2"
            stroke="url(#paint0_linear_1105_6713)"
            stroke-width="5" />
        <defs>
            <linearGradient
                id="paint0_linear_1105_6713"
                x1="85"
                y1="5.5"
                x2="29"
                y2="100"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="white" />
                <stop
                    offset="1"
                    stop-color="white"
                    stop-opacity="0" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script setup lang="ts"></script>
